// DS2 Accordion: a panel with a title that opens and closes (the native details / summary), for content that need not
// be always in view. extra: a count or a Badge at the right of the title. Open by itself from defaultOpen, or driven by
// open + onToggle; onToggle(open) is called on every change either way.
import cx from "classnames";
import type { PropsWithChildren, ReactNode, Ref } from "react";
import { ChevronDownIcon } from "./icons";
import styles from "./Accordion.module.css";

export type AccordionProps = PropsWithChildren<{
  title: string;
  extra?: ReactNode;
  open?: boolean;
  defaultOpen?: boolean;
  onToggle?: (open: boolean) => void;
  className?: string;
  ref?: Ref<HTMLDetailsElement>;
}>;

export function Accordion({ title, extra, open, defaultOpen, onToggle, children, className, ref }: AccordionProps) {
  const controlled = open !== undefined;
  return (
    <details
      ref={ref}
      className={cx(styles.accordion, className)}
      open={controlled ? open : defaultOpen}
      onToggle={controlled ? undefined : (e) => onToggle?.(e.currentTarget.open)}
    >
      <summary
        className={styles.head}
        onClick={
          controlled
            ? (e) => {
                // the parent decides: the details only follows `open`
                e.preventDefault();
                onToggle?.(!open);
              }
            : undefined
        }
      >
        <ChevronDownIcon className={styles.chevron} />
        <span className={styles.title}>{title}</span>
        {extra != null ? <span className={styles.extra}>{extra}</span> : null}
      </summary>
      <div className={styles.body}>{children}</div>
    </details>
  );
}
